import React from 'react';
import { Card, Button } from 'react-bootstrap';
import styles from './Blog.module.css';

const Blog = () => {
  return (
    <div id="blog" className="container py-5">
      <div className="text-center pb-2">
        <h3 className="title">News</h3>
        <h2 className="subtitle">My Latest Articles</h2>
      </div>
      <div className="row">
        <div className="col-md-7">
          <div className="row">
            <div className="col-md-6">
              <Card>
                <div className={styles.box}>
                  <img
                    className="img-fluid"
                    src="https://images.unsplash.com/photo-1579468118864-1b9ea3c0db4a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80"
                    alt=""
                  />
                  <div className={styles.boxContent}>
                    <h3 className={styles.title}>React.js</h3>
                    <span className={styles.post}></span>
                  </div>
                  <ul className={styles.icon}>
                    <li>
                      <a href="#">
                        <i class="fa fa-search"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-link"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <Card.Body>
                  <p className="text-secondary">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Maiores culpa numquam ducimus? Ullam quos nostrum a, enim
                    repellendus iste perspiciatis aut, voluptas vero quaerat
                    autem officia ut quisquam est debitis?
                  </p>
                  {/* <Button variant="primary">Read More</Button> */}
                  <button>Read More</button>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-6">
              <Card>
                <div className={styles.box}>
                  <img
                    className="img-fluid rounded"
                    src="https://images.unsplash.com/photo-1581276879432-15e50529f34b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=750&q=80lexdevero.com/wp-content/uploads/2015/03/sass-logo.jpg"
                    alt=""
                  />
                  <div className={styles.boxContent}>
                    <h3 className={styles.title}>GatsBy</h3>
                    <span className={styles.post}></span>
                  </div>
                  <ul className={styles.icon}>
                    <li>
                      <a href="#">
                        <i class="fa fa-search"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-link"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <Card.Body>
                  <p className="text-secondary">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Maiores culpa numquam ducimus? Ullam quos nostrum a, enim
                    repellendus iste perspiciatis aut, voluptas vero quaerat
                    autem officia ut quisquam est debitis?
                  </p>
                  <button>Read More</button>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div className="row">
            <div className="col-md-12">
              <div className="card mb-3">
                <div className="row no-gutters">
                  <div className="col-md-5">
                    <img
                      style={{ width: '100%', height: '100%' }}
                      className="img-fluid rounded"
                      src="https://images.unsplash.com/photo-1580121441575-41bcb5c6b47c?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80"
                      alt=""
                    />
                  </div>
                  <div className="col-md-7">
                    <div className="card-body">
                      <h5 className="card-title">Django</h5>
                      {/* <p className="card-text">Card Text</p> */}
                      <p className="card-text">
                        <small className="text-muted">
                          Lorem ipsum, dolor sit amet consectetur adipisicing
                          elit. Laboriosam ex quod assumenda!
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="card mb-3">
                <div className="row no-gutters">
                  <div className="col-md-5">
                    <img
                      style={{ width: '100%', height: '100%' }}
                      className="img-fluid rounded"
                      src="https://images.unsplash.com/photo-1550432163-9cb326104944?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=750&q=80"
                      alt=""
                    />
                  </div>
                  <div className="col-md-7">
                    <div className="card-body">
                      <h5 className="card-title">Wall-E</h5>
                      {/* <p className="card-text">Card Text</p> */}
                      <p className="card-text">
                        <small className="text-muted">
                          Lorem ipsum, dolor sit amet consectetur adipisicing
                          elit. Quae totam corrupti dicta.
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="card mb-3">
                <div className="row no-gutters">
                  <div className="col-md-5">
                    <img
                      style={{ width: '100%', height: '100%' }}
                      className="img-fluid rounded"
                      src="https://images.unsplash.com/photo-1516414447565-b14be0adf13e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=666&q=80"
                      alt=""
                    />
                  </div>
                  <div className="col-md-7">
                    <div className="card-body">
                      <h5 className="card-title">Paper</h5>
                      {/* <p className="card-text">Card Text</p> */}
                      <p className="card-text">
                        <small className="text-muted">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
